<template>
    <div>
        <v-card class="mt-2">
            <v-card-title class="pa-2">
                <v-btn color="primary" class="m-0" @click="onBackKey"><v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>Back</v-btn>
                <v-spacer></v-spacer>
                <label v-if="licenses.length == 1">{{licenses[0].licenseKey}}</label>
                <label v-else>{{licenses.length}} License(s)</label>
                <v-spacer></v-spacer>
            </v-card-title>
        </v-card>
        <v-card class="mt-2" :loading="isBusy">
            <v-stepper non-linear v-model="licenseStep" alt-labels>
                <v-stepper-header>
                    <v-stepper-step editable step="A">Active</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="D">Dealer</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="E">Expires</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="F">Firm</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="H">Handshake</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="X">Instances</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="I">Institutes</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="P">Products</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="S">System</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="T">Type</v-stepper-step>
                </v-stepper-header>
                <v-stepper-content step="A">
                    <v-layout pa-4>
                        <v-row>
                            <v-col>
                                <v-checkbox ref="activeSwitch" label="Active" v-model="activeValue"></v-checkbox>
                                <v-row>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" class="m-0" @click="onSaveActiveClick"><v-icon left>mdi-content-save</v-icon>Save Active</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-layout>
                </v-stepper-content>
                <v-stepper-content step="D">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Dealers</label>
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="dealerTable.filter" append-icon="mdi-filter-outline" label="Filter" single-line hide-details clearable></v-text-field>
                                </v-card-title>
                                <v-data-table dense v-model="dealerTable.selected" :single-select="dealerTable.singleSelect" show-select item-key="dealerGUID" :headers="dealerTable.headers" :items="dealerTable.dealers" :search="dealerTable.filter" :loading="isBusy" :loading-text="dealerTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" :disabled="dealerTable.selected.length == 0" @click="clickSaveDealer"><v-icon left>mdi-content-save</v-icon>Save Dealer</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="E">
                    <v-row>
                        <v-col>
                                <v-card-title class="pa-2">
                                    <label>Expires</label>
                                </v-card-title>
                                <v-row>
                                <v-spacer/>
                                <v-col>
                                    <v-date-picker v-model="expirationValue"></v-date-picker>
                                </v-col>
                                <v-col>
                                    <v-btn color="primary" class="mb-6" @click="onExpirationClick(0)" block><v-icon left>mdi-calendar</v-icon>This Month</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(1)" block>1 Month</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(3)" block>3 Months</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(6)" block>6 Months</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(12)" block>12 Months</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(18)" block>18 Months</v-btn>
                                    <v-btn color="primary" class="mb-5" @click="onExpirationClick(24)" block>24 Months</v-btn>
                                </v-col>
                                <v-spacer/>
                            </v-row>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" @click="onSaveExpirationClick"><v-icon left>mdi-content-save</v-icon>Save Expiration</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="F">
                    <v-row>
                        <v-col>
                            <v-card class="mb-2">
                                <v-card-title class="pa-2">
                                    <v-row>
                                        <v-col>
                                            <label><v-icon left>mdi-magnify</v-icon>Search</label>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-row>
                                                <v-text-field ref="firmSearch" label="Firm Code or Name" prepend-inner-icon="mdi-magnify" v-model="firmTable.searchFor" outlined dense single-line rounded clearable hide-details @keyup.native="onFirmSearchKey"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col>
                                            <v-btn color="primary" class="ml-4" @click="confirmSearchFirms"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                            </v-card>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <v-row>
                                        <v-col>
                                            <label><v-icon left>mdi-account</v-icon>Firms</label>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field v-model="firmTable.filter" label="Filter" prepend-inner-icon="mdi-filter-outline" outlined dense single-line rounded clearable hide-details v-show="firmTable.firms.length > 0"></v-text-field>
                                        </v-col>
                                        <v-col>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-data-table dense v-model="firmTable.selected" :single-select="firmTable.singleSelect" show-select item-key="firmGUID" :headers="firmTable.headers" :items="firmTable.firms" :search="firmTable.filter" :loading="isBusy" :loading-text="firmTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" :disabled="firmTable.selected.length == 0" @click="clickSaveFirm"><v-icon left>mdi-content-save</v-icon>Save Firm</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="H">
                    <v-layout pa-4>
                        <v-row>
                            <v-col>
                                <v-checkbox ref="handshakeFailBlockSwitch" label="Handshake Fail Block" v-model="handshakeFailBlockValue"></v-checkbox>
                                <v-row>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" class="m-0" @click="onSaveHandshakeFailBlockClick"><v-icon left>mdi-content-save</v-icon>Save Handshake Fail Block</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-layout>
                </v-stepper-content>
                <v-stepper-content step="X">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Instance Limit</label>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-row class="pt-4">
                                    <v-col class="pr-8 pl-8">
                                        <v-slider v-model="instanceLimit" class="align-center" :max="instanceLimitMax" :min="instanceLimitMin" hide-details thumb-label="always" thumb-size="32">
                                        </v-slider>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" @click="clickSaveInstanceLimit"><v-icon left>mdi-content-save</v-icon>Save Instance Limit</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="I">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Institutes</label>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-data-table dense v-model="instituteTable.selected" :single-select="instituteTable.singleSelect" show-select item-key="institute" :headers="instituteTable.headers" :items="instituteTable.institutes" :loading="isBusy" :loading-text="instituteTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" :disabled="instituteTable.selected.length == 0" @click="clickSaveInstitutes"><v-icon left>mdi-content-save</v-icon>Save Institute(s)</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="P">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Products</label>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-data-table dense v-model="productTable.selected" :single-select="productTable.singleSelect" show-select item-key="product" :headers="productTable.headers" :items="productTable.products" :loading="isBusy" :loading-text="productTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" @click="clickSaveProducts"><v-icon left>mdi-content-save</v-icon>Save Product(s)</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="S">
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-card elevation="0">
                            <v-card-title class="ml-4 pa-2">
                                <label>Clear System IDs</label>
                            </v-card-title>
                            <v-btn color="primary" class="ml-4" @click="clickClearSystemIDs"><v-icon left>mdi-content-save</v-icon>Clear System ID(s)</v-btn>
                        </v-card>
                        <v-spacer></v-spacer>
                        <v-card elevation="0">
                            <v-card-title class="pa-2">
                                <label>Strict System IDs</label>
                            </v-card-title>
                            <v-checkbox ref="strictSystemIDsSwitch" label="Struct System IDs" v-model="strictSystemIDsValue"></v-checkbox>
                            <v-btn color="primary" class="mr-4" @click="clickSaveStrictSystemIDs"><v-icon left>mdi-content-save</v-icon>Save Strict System IDs</v-btn>
                        </v-card>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="T">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Type</label>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-data-table dense v-model="typeTable.selected" :single-select="typeTable.singleSelect" show-select item-key="type" :headers="typeTable.headers" :items="typeTable.types" :loading="isBusy" :loading-text="typeTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-4" :disabled="typeTable.selected.length == 0" @click="clickSaveLicenseType"><v-icon left>mdi-content-save</v-icon>Save License Type</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper>
        </v-card>
        <v-snackbar v-model="snackbar.visible" color="primary" :timeout="snackbar.timeout" :bottom="snackbar.bottom">
            Saved
            <v-btn dark text @click="snackbar.visible=false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
// import moment from "moment";

export default {
    name: "Licenses",
    selectedItems: [],
    props: {
        licenses: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            title: "License Values",
            isBusy: false,
            snackbar: {
                visible: false,
                timeout: 1000,
                bottom: true,
            },
            licenseStep: "A",
            codes: "",
            activeValue: true,
            strictSystemIDsValue: true,
            handshakeFailBlockValue: false,
            expirationValue: new Date().toISOString().substr(0, 10),
            instanceLimitMin: 0,
            instanceLimitMax: 50,
            instanceLimit: 0,
            dealerTable: {
                selected: [],
                singleSelect: true,
                filter: "",
                searchFor: "",
                itemKey: "dealerId",
                loadingText: "loading dealers",
                headers: [
                    { text: "Dealer", value: "dealer" },
                ],
                dealers: [],
            },
            firmTable: {
                selected: [],
                singleSelect: true,
                filter: "",
                searchFor: "",
                itemKey: "firmGUID",
                loadingText: "loading firms",
                headers: [
                    { text: "Code", value: "firmGUID" },
                    { text: "Firm", value: "firm" },
                ],
                firms: [],
            },
            instituteTable: {
                selected: [],
                singleSelect: true,
                itemKey: "instituteGUID",
                loadingText: "loading institutes",
                headers: [
                    { text: "Institute", value: "institute" },
                ],
                institutes: [
                    { instituteGUID: "IAC", institute: "IAC" },
                    { instituteGUID: "SAIBA", institute: "SAIBA" },
                    { instituteGUID: "SAICA", institute: "SAICA" },
                    { instituteGUID: "SAIPA", institute: "SAIPA" },
                    { instituteGUID: "Other", institute: "Other" },
                ],
            },
            productTable: {
                selected: [],
                singleSelect: false,
                itemKey: "product",
                loadingText: "loading products",
                headers: [
                    { text: "Product", value: "product" },
                ],
                products: [
                    { productGUID: "IFRS", product: "IFRS" },
                    { productGUID: "GRAP", product: "GRAP" },
                    { productGUID: "RAC", product: "RAC" },
                    { productGUID: "CET", product: "CET" },
                    { productGUID: "TVET", product: "TVET" },
                    { productGUID: "CLOUD", product: "CLOUD" },
                ],
            },
            typeTable: {
                selected: [],
                singleSelect: true,
                itemKey: "type",
                loadingText: "loading types",
                headers: [
                    { text: "Type", value: "type" },
                ],
                types: [
                    { typeGUID: "FULL", type: "Full" },
                    { typeGUID: "DEMO", type: "Demo" },
                    { typeGUID: "EDUCATIONAL", type: "Educational" },
                    { typeGUID: "READ_ONLY", type: "Read-Only" },
                    { typeGUID: "XBRL", type: "XBRL" },
                ],
            },
        };
    },
    mounted() {
        this.searchDealers();
    },
    methods: {
        onBackKey() {
            this.$emit("onBackKey");
        },
        onFirmSearchKey(evt) {
            if (evt.key === "Enter") {
                this.confirmSearchFirms();
            }
        },
        onSaveActiveClick() {
            this.setLicenseValues("active", (this.activeValue === true ? 1 : 0));
        },
        clickSaveDealer() {
            this.setLicenseValues("dealerGUID", this.dealerTable.selected[0].dealerGUID);
        },
        onSaveHandshakeFailBlockClick() {
            this.setLicenseValues("handshakeFailBlock", (this.handshakeFailBlockValue === true ? 1 : 0));
        },
        clickSaveInstanceLimit() {
            this.setLicenseValues("instanceLimit", this.instanceLimit);
        },
        clickSaveInstitutes() {
            this.prepareInstitutes();
            setTimeout(() => {
                this.setLicenseValues("institutes", this.institutes);
            }, 100);
        },
        clickSaveProducts() {
            this.prepareProducts();
            setTimeout(() => {
                this.setLicenseValues("products", this.products);
            }, 100);
        },
        clickClearSystemIDs() {
            setTimeout(() => {
                this.setLicenseValues("system", "");
            }, 100);
        },
        onSaveExpirationClick() {
            this.setLicenseValues("expires", this.expirationValue);
        },
        clickSaveLicenseType() {
            this.prepareTypes();
            setTimeout(() => {
                this.setLicenseValues("type", this.types);
            }, 100);
        },
        clickSaveFirm() {
            this.setLicenseValues("firmGUID", this.firmTable.selected[0].firmGUID);
        },
        onExpirationClick(months) {
            const today = new Date();
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + months + 1, 1);
            this.expirationValue = lastDayOfMonth.toISOString().substr(0, 10);
        },
        clickSaveStrictSystemIDs() {
            this.setLicenseValues("strictSystemIDs", (this.strictSystemIDsValue === true ? 1 : 0));
        },
        setLicenseValues(propertyName, saveValue) {
            this.prepareCodes();
            this.$confirm({
                title: "Confirm Save",
                message: "Are you sure you wish to save?",
            }, (value) => {
                if (value) {
                    this.isBusy = true;
                    this.$http
                        .post(`/api/license/property`, {
                            application: this.$global.application,
                            property: propertyName,
                            licenses: this.codes,
                            value: saveValue,
                        })
                        .then(() => {
                            this.isBusy = false;
                            this.snackbar.visible = true;

                            switch (propertyName) {
                                case "active":
                                case "handshakeFailBlock":
                                    this.licenses.forEach((element) => {
                                        element[propertyName] = saveValue === 1;
                                    });
                                    break;

                                case "institutes":
                                    this.licenses.forEach((element) => {
                                        element.iac = saveValue.includes("IAC");
                                        element.saiba = saveValue.includes("SAIBA");
                                        element.saica = saveValue.includes("SAICA");
                                        element.saipa = saveValue.includes("SAIPA");
                                        element.other = saveValue.includes("Other");
                                    });
                                    break;

                                case "products":
                                    this.licenses.forEach((element) => {
                                        element.ifrs = saveValue.includes("IFRS");
                                        element.grap = saveValue.includes("GRAP");
                                        element.rac = saveValue.includes("RAC");
                                        element.cet = saveValue.includes("CET");
                                        element.tvet = saveValue.includes("TVET");
                                        element.cloud = saveValue.includes("CLOUD");
                                    });
                                    break;

                                case "system":
                                    this.licenses.forEach((element) => {
                                        element[propertyName] = "";
                                    });
                                    break;

                                case "type":
                                    this.licenses.forEach((element) => {
                                        element.licenseTypeGUID = saveValue.replace(",", "");
                                    });
                                    break;

                                default:
                                    this.licenses.forEach((element) => {
                                        element[propertyName] = saveValue;
                                    });
                                    break;
                            }

                            this.$ga.event({
                                eventCategory: "licenses",
                                eventAction: `update.${propertyName}`,
                            });
                        })
                        .catch((err) => {
                            debugger;
                            this.isBusy = false;
                            if (err.response.status === 401) {
                                this.$router.push({ name: "login" });
                            }
                            else {
                                this.$alert({ type: "error", title: "Save Failed", message: err.response.data.exceptionMessage });
                            }
                        });
                }
            });
        },
        searchDealers() {
            this.isBusy = true;
            this.dealerTable.dealers = [];
            this.dealerTable.selected = [];

            this.$http
                .get(`/api/dealer/search/${this.dealerTable.searchFor}/`)
                .then((response) => {
                    this.dealerTable.dealers = response.data;
                    this.isBusy = false;
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        confirmSearchFirms() {
            if (this.firmTable.searchFor === "") {
                this.$confirm({
                    title: "Confirm Search",
                    message: "Are you sure you wish to load all firms?",
                }, (value) => {
                    if (value) {
                        this.searchFirms();
                    }
                });
            }
            else {
                this.searchFirms();
            }
        },
        searchFirms() {
            this.isBusy = true;
            this.firmTable.firms = [];
            this.firmTable.selected = [];

            this.$http
                .get(`/api/firm/search/${this.firmTable.searchFor}/`)
                .then((response) => {
                    this.firmTable.firms = response.data;
                    this.isBusy = false;
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        prepareCodes() {
            this.codes = "";
            this.licenses.forEach((element) => {
                this.codes = `${this.codes},${element.licenseKey}`;
            });
        },
        prepareInstitutes() {
            this.institutes = "";
            this.instituteTable.selected.forEach((element) => {
                this.institutes = `${this.institutes},${element.instituteGUID}`;
            });
        },
        prepareProducts() {
            this.products = "";
            this.productTable.selected.forEach((element) => {
                this.products = `${this.products},${element.productGUID}`;
            });
        },
        prepareTypes() {
            this.types = "";
            this.typeTable.selected.forEach((element) => {
                this.types = `${this.types},${element.typeGUID}`;
            });
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
    },
};
</script>
